import { put, call, takeLatest, select } from 'redux-saga/effects';

import fbEmmiter from '../../../events/facebookEvents';
import { formatError } from '../../../libs';
import whatsAppAPI from '../../api/whatsApp';
import { Types, Creators } from '../../reducers/whatsApp';
import getState from '../../utils/getState';

function* whatsAppRequest({ userData }) {
  try {
    const { app } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);

    const sendData = {
      ...userData,
      url: app.getIn(['query', 'url']) || window.location.href,
    };

    const data = yield call(whatsAppAPI.sendContact, sendData, siteId);

    yield put(Creators.whatsAppSuccess(data));

    fbEmmiter('Contact');
  } catch (error) {
    yield put(Creators.whatsAppFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.WHATS_APP_REQUEST, whatsAppRequest);
}
